// Define student loan constants for each tax year
const STUDENT_LOAN_PLANS = {
  "2023/2024": {
    PLAN_1: {
      THRESHOLD: 22015,
      RATE: 0.09
    },
    PLAN_2: {
      THRESHOLD: 27295,
      RATE: 0.09
    },
    PLAN_4: {
      THRESHOLD: 27660,
      RATE: 0.09
    },
    PLAN_5: {
      THRESHOLD: 25000,
      RATE: 0.09
    },
    POSTGRAD: {
      THRESHOLD: 21000,
      RATE: 0.06
    }
  },
  "2024/2025": {
    PLAN_1: {
      THRESHOLD: 22095,
      RATE: 0.09
    },
    PLAN_2: {
      THRESHOLD: 27295,
      RATE: 0.09
    },
    PLAN_4: {
      THRESHOLD: 31395, // Scotland
      RATE: 0.09
    },
    PLAN_5: {
      THRESHOLD: 25000,
      RATE: 0.09
    },
    POSTGRAD: {
      THRESHOLD: 21000,
      RATE: 0.06
    }
  },
  "2025/2026": {
    PLAN_1: {
      THRESHOLD: 22560,
      RATE: 0.09
    },
    PLAN_2: {
      THRESHOLD: 27295,
      RATE: 0.09
    },
    PLAN_4: {
      THRESHOLD: 32025, // Scotland
      RATE: 0.09
    },
    PLAN_5: {
      THRESHOLD: 25000,
      RATE: 0.09
    },
    POSTGRAD: {
      THRESHOLD: 21000,
      RATE: 0.06
    }
  }
};

// Export this alongside your existing exports
export const TAX_YEARS = {
  "2023/2024": {
    UK: {
      MAX_PENSION_AMOUNT: 60000,
      TAX_BASIC_RATE_LIMIT: 37700,
      TAX_BASIC_RATE: 0.2,
      TAX_HIGHER_RATE_LIMIT: 125140,
      TAX_HIGHER_RATE: 0.4,
      TAX_ADDITIONAL_RATE: 0.45,
      ANNUAL_PERSONAL_ALLOWANCE_THRESHOLD: 100000,
      ANNUAL_PERSONAL_ALLOWANCE: 12570,
      NIC_PRIMARY_THRESHOLD: 12570,
      NIC_UPPER_EARNINGS_LIMIT: 50270,
      NIC_UPPER_RATE: 0.02,
      NIC_LOWER_RATE: 0.12,
      CGT_EXEMPT_AMOUNT: 6000,
      CGT_BASIC_RATE_LIMIT: 37700,
      CGT_LOWER_RATE: 0.1,
      CGT_HIGHER_RATE: 0.2,
    },
    SCOTLAND: {
      MAX_PENSION_AMOUNT: 60000,
      STARTER_RATE: 0.19,
      BASIC_RATE: 0.20,
      INTERMEDIATE_RATE: 0.21,
      HIGHER_RATE: 0.41,
      TOP_RATE: 0.46,
      STARTER_RATE_LIMIT: 14732,
      BASIC_RATE_LIMIT: 25688,
      INTERMEDIATE_RATE_LIMIT: 43662,
      HIGHER_RATE_LIMIT: 125140,
      ANNUAL_PERSONAL_ALLOWANCE_THRESHOLD: 100000,
      ANNUAL_PERSONAL_ALLOWANCE: 12570,
    },
    STUDENT_LOANS: STUDENT_LOAN_PLANS["2023/2024"],
  },
  "2024/2025": {
    UK: {
      MAX_PENSION_AMOUNT: 60000,
      TAX_BASIC_RATE_LIMIT: 37700,
      TAX_BASIC_RATE: 0.2,
      TAX_HIGHER_RATE_LIMIT: 125140,
      TAX_HIGHER_RATE: 0.4,
      TAX_ADDITIONAL_RATE: 0.45,
      ANNUAL_PERSONAL_ALLOWANCE_THRESHOLD: 100000,
      ANNUAL_PERSONAL_ALLOWANCE: 12570,
      NIC_PRIMARY_THRESHOLD: 12570,
      NIC_UPPER_EARNINGS_LIMIT: 50270,
      NIC_UPPER_RATE: 0.02,
      NIC_LOWER_RATE: 0.08,
      CGT_EXEMPT_AMOUNT: 3000,
      CGT_BASIC_RATE_LIMIT: 50270,
      CGT_LOWER_RATE: 0.1,
      CGT_HIGHER_RATE: 0.2,
    },
    SCOTLAND: {
      MAX_PENSION_AMOUNT: 60000,
      STARTER_RATE: 0.19,
      BASIC_RATE: 0.20,
      INTERMEDIATE_RATE: 0.21,
      HIGHER_RATE: 0.42,
      TOP_RATE: 0.48,
      STARTER_RATE_LIMIT: 14876,
      BASIC_RATE_LIMIT: 26561,
      INTERMEDIATE_RATE_LIMIT: 43662,
      HIGHER_RATE_LIMIT: 75000,
      ADVANCED_RATE_LIMIT: 125140,
      ANNUAL_PERSONAL_ALLOWANCE_THRESHOLD: 100000,
      ANNUAL_PERSONAL_ALLOWANCE: 12570,
    },
    STUDENT_LOANS: STUDENT_LOAN_PLANS["2024/2025"],
  },
  "2025/2026": {
    UK: {
      MAX_PENSION_AMOUNT: 60000,
      TAX_BASIC_RATE_LIMIT: 37700,
      TAX_BASIC_RATE: 0.2,
      TAX_HIGHER_RATE_LIMIT: 125140,
      TAX_HIGHER_RATE: 0.4,
      TAX_ADDITIONAL_RATE: 0.45,
      ANNUAL_PERSONAL_ALLOWANCE_THRESHOLD: 100000,
      ANNUAL_PERSONAL_ALLOWANCE: 12570,
      NIC_PRIMARY_THRESHOLD: 12570,
      NIC_UPPER_EARNINGS_LIMIT: 50270,
      NIC_UPPER_RATE: 0.02,
      NIC_LOWER_RATE: 0.08,
      CGT_EXEMPT_AMOUNT: 3000,
      CGT_BASIC_RATE_LIMIT: 50270,
      CGT_LOWER_RATE: 0.1,
      CGT_HIGHER_RATE: 0.2,
    },
    SCOTLAND: {
      MAX_PENSION_AMOUNT: 60000,
      STARTER_RATE: 0.19,
      BASIC_RATE: 0.20,
      INTERMEDIATE_RATE: 0.21,
      HIGHER_RATE: 0.42,
      ADVANCED_RATE: 0.45,
      TOP_RATE: 0.48,
      STARTER_RATE_LIMIT: 15397,
      BASIC_RATE_LIMIT: 27491,
      INTERMEDIATE_RATE_LIMIT: 43662,
      HIGHER_RATE_LIMIT: 75000,
      ADVANCED_RATE_LIMIT: 125140,
      ANNUAL_PERSONAL_ALLOWANCE_THRESHOLD: 100000,
      ANNUAL_PERSONAL_ALLOWANCE: 12570,
    },
    STUDENT_LOANS: STUDENT_LOAN_PLANS["2025/2026"],
  }
};

export const STUDENT_LOAN_PLAN_NAMES = {
PLAN_1: "Plan 1 (Pre-2012 Undergraduate Loans)",
PLAN_2: "Plan 2 (Post-2012 Undergraduate Loans)",
PLAN_4: "Plan 4 (Scottish Loans)",
PLAN_5: "Plan 5 (Post-2023 Undergraduate Loans)",
POSTGRAD: "Postgraduate Loan"
};